export { default as AppleIcon } from './AppleIcon';
